/**
 * @generated SignedSource<<859eb43cced06ccf178fb466f1d1e29b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClientStatusStanding = "ACTIVE" | "INACTIVE" | "%future added value";
export type CompanyViewPage_Query$variables = {
  clientId?: string | null;
};
export type CompanyViewPage_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly company: {
      readonly id: string;
      readonly client: {
        readonly id: string;
        readonly name: string;
        readonly website: string | null;
        readonly city: string | null;
        readonly country: string | null;
        readonly region: string | null;
        readonly statusId: string | null;
        readonly createdAt: string | null;
        readonly updatedAt: string | null;
        readonly status: {
          readonly id: string;
          readonly label: string;
          readonly standing: ClientStatusStanding;
        } | null;
        readonly primaryContact: {
          readonly id: string;
          readonly firstName: string | null;
          readonly lastName: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};
export type CompanyViewPage_Query = {
  variables: CompanyViewPage_Query$variables;
  response: CompanyViewPage_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clientId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Company",
  "kind": "LinkedField",
  "name": "company",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "clientId"
        }
      ],
      "concreteType": "Client",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "website",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "region",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "statusId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientStatus",
          "kind": "LinkedField",
          "name": "status",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "label",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "standing",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientContact",
          "kind": "LinkedField",
          "name": "primaryContact",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyViewPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyViewPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aeb968ffdc614719ae359a9c99a2c339",
    "id": null,
    "metadata": {},
    "name": "CompanyViewPage_Query",
    "operationKind": "query",
    "text": "query CompanyViewPage_Query(\n  $clientId: String\n) {\n  viewer {\n    actualPersonId\n    company {\n      id\n      client(id: $clientId) {\n        id\n        name\n        website\n        city\n        country\n        region\n        statusId\n        createdAt\n        updatedAt\n        status {\n          id\n          label\n          standing\n        }\n        primaryContact {\n          id\n          firstName\n          lastName\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a85ebf51f73d47124aceda3ac32bb096";

export default node;
